// @flow strict
import React from 'react';
// import AdBlockDetect from 'react-ad-block-detect';
import Author from './Author';
import Contacts from './Contacts';
// import Copyright from './Copyright';
import Menu from './Menu';
import styles from './Sidebar.module.scss';
import { useSiteMetadata, useCustomerLogos } from '../../hooks';

import CustomerCarousel from './CustomerCarousel';
import Twitter from './Twitter';
import Breakpoint from './Breakpoint';

type Props = {
  isIndex?: boolean,
  pathname: string
};

const Sidebar = ({ isIndex, pathname }: Props) => {
  const { author, menu } = useSiteMetadata();
  return (
    <div className={styles['sidebar']}>
      <div className={styles['sidebar__inner']}>
        <Author author={author} isIndex={isIndex} />
        <Menu menu={menu} />
        <Contacts contacts={author.contacts} />
        <Breakpoint name="desktop">
          <Twitter screenName={author.contacts.twitter} isIndex={pathname !== '/pages/about'} />
          <CustomerCarousel customerLogos={useCustomerLogos()} isIndex={pathname === '/pages/about'} />
        </Breakpoint>
        {/* <AdBlockDetect>
            <p>Show this if an ad blocker has been enabled.</p>
        </AdBlockDetect> */}
      </div>
    </div>
  );
};

export default Sidebar;
